import {
  PAY_OUT_OF_POCKET,
  REMOVE,
  ADD_DIAGNOSIS_CHECKOUT,
  PPS_IN_HOSPITAL_LAST_60DAYS_YES,
  PPS_IN_HOSPITAL_DISCHARGE_YES,
  PPS_IN_HOSPITAL_DISCHARGE_NO,
  PPS_IN_SKILLED_NURSERY_YES
} from '../utilities/constant_config';
import { htmlGet } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import { selectmenuAccessibilityCompliance } from '../utilities/helper';
import {
  checkWidth,
  checkHeight,
  setvariableValue
} from '../utilities/utility';

const $doc = $(document);
const milisecondInaDay = 86400000;
const checkoutHospotalDischargeDate = '#checkoutDiagnosisDischargeDate';
const wereUDischarged = '#question2';
const hospitalDischargeDate = '#question3';
const showHospitalQuestions = '.showHospitalQuestions';
const showCoverageScreen = '.showCoverageScreen';
const submitCheckoutHospitalQuestions = '.submitCheckoutHospitalAnswers';
const requiredHospitalQuestions = '.required-hospital-questions';
const wereudischargeRadio = '.question2';
const hospitalCountRadio = '.question1';
const clsDiagnosisColorBox = 'checkout-diagnosis';
const removePopup = '#removeOrderPopup';
const cboxOverlay = '#cboxOverlay';
const diagnosisValidationCartSize = '#diagnosisCartSize';
const clsDiagnosisSubmitRemovePopup = '.submitRemoveItemForm';
const clsDiagnosisRemovePopup = '#colorbox.checkout-diagnosis';
const checkoutDiagnosisNextStep =
  '.checkout-validation__diagnosis .checkoutNextStepResolution';
const checkoutValidationDiagnosis = '.checkout-validation__diagnosis';
const checkoutDiagnosisResolveRadio =
  '.checkout-validation__diagnosis .checkout-resolution-options-radio';
const diagnosisForm = $('#diagnosisPage');
const cboxTitle = '#cboxTitle';
let checkoutAddDiagnosisFormAjaxFlag = true;
let nextStepButtonActionPPSQFlag = false;
let nextStepCheckoutDignosisButtonFlag = false;
const checkoutDiagnosis = {
  hideDischargeDateQuestions() {
    $('.question1').each(function() {
      $(this).attr('required', true);
    });
    $('.question4').each(function() {
      $(this).attr('required', true);
    });
  },
  initializeHospitalDiachargeDatePicker() {
    $(checkoutHospotalDischargeDate).datepicker();
  },
  showIfDischarged() {
    if ($(this).val() === PPS_IN_HOSPITAL_LAST_60DAYS_YES) {
      $(wereUDischarged).show();
      $(wereudischargeRadio).each(function() {
        $(this).attr('required', true);
      });
    } else {
      $(wereUDischarged).hide();
      $(hospitalDischargeDate).hide();
      $(checkoutHospotalDischargeDate).val('');
      $(wereudischargeRadio).each(function() {
        $(this).removeAttr('required');
        $(this).prop('checked', false);
      });
      $(checkoutHospotalDischargeDate).removeAttr('required');
    }
  },
  showDischargedDate() {
    if ($(this).val() === PPS_IN_HOSPITAL_DISCHARGE_YES) {
      $(hospitalDischargeDate).show();
      $(checkoutHospotalDischargeDate).attr('required', true);
    } else {
      $(hospitalDischargeDate).hide();
      $(checkoutHospotalDischargeDate).val('');
      $(checkoutHospotalDischargeDate).removeAttr('required');
    }
  },
  checkoutDiagnosisActive() {
    $(checkoutDiagnosisNextStep).removeAttr('disabled');
  },
  openRemoveModal() {
    ACC.colorbox.open('', {
      html: $(removePopup).html(),
      onLoad: $(cboxOverlay).css('position', 'fixed'),
      width: checkWidth(),
      height: checkHeight,
      className: clsDiagnosisColorBox
    });
    $(cboxTitle).remove();
  },
  addDiagnosisForm() {
    if (window.location.pathname.indexOf('checkout') > -1) {
      if (!checkoutAddDiagnosisFormAjaxFlag) return false;
      checkoutAddDiagnosisFormAjaxFlag = false;
      htmlGet(API_REFERENCE.checkoutDiagnosis.getDiagnosisSurveyForm)
        .then(response => {
          checkoutAddDiagnosisFormAjaxFlag = true;
          const data = ACC.sanitizer.sanitizeHtmlDeeply(response);
          $(checkoutValidationDiagnosis).html(data);
          $('.mydiagnosis').html(data);
          $('.survey_modal_resolve, .checkoutDiagnosisBack').show();
          $('.diagnosisSurvey__button--cancel').hide();
          $(checkoutValidationDiagnosis).removeClass('pt-4');
          $('[data-toggle="tooltip"]').tooltip();
          $('#categoryDropdown').selectmenu();

          selectmenuAccessibilityCompliance();
        })
        .catch(() => {
          checkoutAddDiagnosisFormAjaxFlag = true;
        });
    }
  },
  backToCheckoutDiagnosis() {
    window.location.reload(true);
  },
  submitDiagnosisResolutionForm() {
    setvariableValue('checkoutDiagnosisForm', diagnosisForm);
    const resolutionType = $('input[name=resolutionType]:checked').val();
    if (resolutionType === PAY_OUT_OF_POCKET) {
      if(!nextStepCheckoutDignosisButtonFlag){
        nextStepCheckoutDignosisButtonFlag = true;
        diagnosisForm.submit();
      }
    } else if (resolutionType === REMOVE) {
      if ($(diagnosisValidationCartSize).val() === '1') {
        checkoutDiagnosis.openRemoveModal();
      } else {
        if(!nextStepCheckoutDignosisButtonFlag){
          nextStepCheckoutDignosisButtonFlag = true;
          diagnosisForm.submit();
        }
      }
    } else if (resolutionType === ADD_DIAGNOSIS_CHECKOUT) {
      checkoutDiagnosis.addDiagnosisForm();
    }
  },
  cancelCheckoutDiagnosisOrder() {
    $('#cancelOrderForm').submit();
  },
  preventNextStepButton(){
    $('#diagnosis_next-step_btn').css('pointer-events','none');
    let dataUrl = $('#diagnosis_next-step_btn').attr('data-url');
    window.location.href= dataUrl; 
  },
  validateDateRange(dateVal) {
    const dateToCheck = new Date(dateVal);
    const maxDate = new Date();
    const minDate = new Date(maxDate - 90 * milisecondInaDay);
    if (dateToCheck > maxDate || dateToCheck < minDate) {
      return false;
    } else {
      return true;
    }
  },
  validateRequiredFields() {
    let isEmpty = false;
    let textEntered = true;
    let radioSelected = true;

    if ($('input[type=text]:required').length > 0) {
      $('input[type=text]:required').each(function() {
        if ($(this).val() === '') textEntered = false;
      });
    }

    if ($('input[type=radio]:required').length > 0) {
      $('input[type=radio]:required').each(function() {
        const name = $(this).attr('name');

        if ($(`input:radio[name=${name}]:checked`).length === 0) {
          radioSelected = false;
        }
      });
    }

    if (radioSelected && textEntered) isEmpty = false;
    else isEmpty = true;

    if (!isEmpty) {
      $(requiredHospitalQuestions).hide();
      if (
        $('input[name="question4"]:checked').val() ===
          PPS_IN_SKILLED_NURSERY_YES ||
        ($('input[name="question1"]:checked').val() ===
          PPS_IN_HOSPITAL_LAST_60DAYS_YES &&
          $('input[name="question2"]:checked').val() ===
            PPS_IN_HOSPITAL_DISCHARGE_NO)
      ) {
        $(showHospitalQuestions).hide();
        $(showCoverageScreen).show();
      } else {
        let dateRangeValid = null;
        let discharegDateValue = $(checkoutHospotalDischargeDate).val();
        if (discharegDateValue !== null || discharegDateValue !== undefined) {
          dateRangeValid = checkoutDiagnosis.validateDateRange(
            discharegDateValue
          );
        }
        if (dateRangeValid) {
          $(checkoutHospotalDischargeDate)
            .next()
            .hide();
          const hospitalQuestionsAnswered = [
            'question1',
            'question2',
            'question4'
          ];
          let answersSelectedForHospitalQuestions = '';
          hospitalQuestionsAnswered.forEach(answer => {
            const hospitalAnswer = $(`input[name=${answer}]:checked`).val();
            if (hospitalAnswer !== undefined) {
              answersSelectedForHospitalQuestions +=
                answersSelectedForHospitalQuestions !== ''
                  ? `,${hospitalAnswer}`
                  : hospitalAnswer;
            }
          });
          if ($('input[name=question3]').val().length > 0) {
            $('input[name=dischargeDate]').val(
              $('input[name=question3]').val()
            );
            answersSelectedForHospitalQuestions += `,${$(
              checkoutHospotalDischargeDate
            ).attr('data-id')}`;
          }
          if(!nextStepButtonActionPPSQFlag){
            nextStepButtonActionPPSQFlag = true;
            $('input[name=answerId]').val(answersSelectedForHospitalQuestions);
            $('#ppsQuestionsForm').submit();
          }
        } else {
          $(checkoutHospotalDischargeDate)
            .next()
            .show();
        }
      }
    } else {
      $(requiredHospitalQuestions).show();
    }
  },
  init() {
    this.hideDischargeDateQuestions();
    this.initializeHospitalDiachargeDatePicker();
    $(hospitalCountRadio).on('click', this.showIfDischarged);
    $(wereudischargeRadio).on('click', this.showDischargedDate);
    $(submitCheckoutHospitalQuestions).on('click', this.validateRequiredFields);
    $(checkoutDiagnosisResolveRadio).on('click', this.checkoutDiagnosisActive);
    $(checkoutDiagnosisNextStep).on(
      'click',
      this.submitDiagnosisResolutionForm
    );
    $doc.on(
      'click',
      `${clsDiagnosisRemovePopup} ${clsDiagnosisSubmitRemovePopup}`,
      function() {
        diagnosisForm.submit();
      }
    );
    $doc.on('click', '.backToCheckoutDiagnosis', this.backToCheckoutDiagnosis);
    $doc.on('click', '.takeDiagnosisSurvey', this.addDiagnosisForm);
    $doc.on('click', '.checkout_Diagnosis_Next_Step_btn', this.preventNextStepButton);
    $doc.on(
      'click',
      '.cancelCheckoutDiagnosisOrder',
      this.cancelCheckoutDiagnosisOrder
    );
  }
};

checkoutDiagnosis.init();

export default checkoutDiagnosis;
